import { useState, useEffect } from 'react';
import { collection, getDocs, doc, addDoc, updateDoc, deleteDoc, serverTimestamp } from 'firebase/firestore';
import { db } from '../firebaseConfig';
import { ParentCategory } from '../types/labelSchema';

export function useParentCategories() {
  const [categories, setCategories] = useState<ParentCategory[]>([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    let mounted = true;

    const loadCategories = async () => {
      try {
        setLoading(true);
        setError(null);
        const snapshot = await getDocs(collection(db, 'objectCategoryParents'));
        if (!mounted) return;

        const data = snapshot.docs.map(doc => ({ id: doc.id, ...doc.data() })) as ParentCategory[];
        setCategories(data);
        setLoading(false);
      } catch (err) {
        console.error('Error loading parent categories:', err);
        if (mounted) {
          setError(`Failed to load parent categories: ${err instanceof Error ? err.message : String(err)}`);
          setLoading(false);
        }
      }
    };

    loadCategories();
    return () => { mounted = false; };
  }, []);

  const createCategory = async (data: {
    name: string;
    displayName: string;
    description?: string;
    color: string;
  }) => {
    const newDoc: Omit<ParentCategory, 'id'> = {
      ...data,
      createdAt: serverTimestamp(),
      createdBy: 'admin',
      updatedAt: serverTimestamp(),
      active: true,
    };
    const ref = await addDoc(collection(db, 'objectCategoryParents'), newDoc);
    return ref.id;
  };

  const updateCategory = async (id: string, updates: Partial<ParentCategory>) => {
    await updateDoc(doc(db, 'objectCategoryParents', id), {
      ...updates,
      updatedAt: serverTimestamp(),
    });
  };

  const deleteCategory = async (id: string) => {
    await deleteDoc(doc(db, 'objectCategoryParents', id));
  };

  return { categories, loading, error, createCategory, updateCategory, deleteCategory };
}





